import { connect } from 'react-redux';
import { IStoreState } from 'src/store';
import { NewVehicleActionCreator, RDWVehicleActionCreator } from 'src/store/states';
import MobileView from 'src/components/AddVehicle/MobileView/MobileView';

const mapStateToProps = (state: IStoreState) => ({
    newVehicleInfo: state.NewVehicle.NewVehicle,
    vehicleSpecs: state.Specs.specs,
    rdwYears: state.RDWVehicle.years,
    rdwMakes: state.RDWVehicle.makes,
    rdwModels: state.RDWVehicle.models,
    makesBuilt: state.RDWVehicle.rdwMakesBuilt,
    yearsBuilt: state.RDWVehicle.rdwYearsBuilt,
    modelsBuilt: state.RDWVehicle.rdwModelsBuilt,
    theme: state.Framework.theme,
    defaultLen: state.Specs.specs?.validMakes.length ?? 0,
    Itype: state.Framework.ImageServerType,
    mainPaneViewOrder: state.Framework.mainPaneViewOrder,
    sessionId: state.Framework.sessionId,
    lexusMCLaunched: state.Framework.lexusMCLaunched,
    toyotaMCLaunched: state.Framework.toyotaMCLaunched,
    lexusTDMCLaunched: state.Framework.lexusTDMCLaunched,
    toyotaTDMCLaunched: state.Framework.toyotaTDMCLaunched,
});

const mapDispatchToProps = {
    onAddNewVehicle: NewVehicleActionCreator.AddNewVehicle,
    getYears: RDWVehicleActionCreator.GetVehicleYears,
    getMakes: RDWVehicleActionCreator.GetVehicleMakes,
    getModels: RDWVehicleActionCreator.GetVehicleModels,
    getStyles: RDWVehicleActionCreator.GetEraStyles,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(MobileView);